@if (attachments().length) {
  <div class="ms-medium-t" data-testid="attachment-list">
    @for (attachment of attachments(); track attachment.file.name) {
      @switch (attachment.status) {
        @case (AttachmentStatus.UPLOADING) {
          <fcom-notification
            class="ms-medium-t"
            data-testid="attachment-uploading"
            [iconName]="SvgLibraryIcon.ATTACHMENT_BLOCK"
            [isLoading]="true"
          >
            {{ attachment.file.name }}
          </fcom-notification>
        }
        @default {
          <fcom-notification
            class="ms-medium-t"
            [closeIcon]="{ name: SvgLibraryIcon.TRASH }"
            [iconName]="SvgLibraryIcon.ATTACHMENT_BLOCK"
            [isClosable]="true"
            (closeClick)="deleteAttachment(attachment)"
            data-testid="attachment"
          >
            {{ attachment.file.name }}
          </fcom-notification>
        }
      }
    }
  </div>
}
